import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad, internalMessageBus } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { Scoreboard } from "./Scoreboard";
import { ScoreboardData } from "./data";

import * as LOCALMOCKSTYPE from "../../Mocks";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
let _LOCALMOCKSTYPE: typeof LOCALMOCKSTYPE;
let BaseballScoreboardDataMock;

if (process.env.NODE_ENV === "development") {
    _LOCALMOCKSTYPE = require("../../Mocks");
    BaseballScoreboardDataMock = _LOCALMOCKSTYPE.BaseballScoreboardDataMock;
}

export class ScoreboardRoot extends BaseBlock {
    dataProvider!: ScoreboardData;
    options!: BaseBlockOptions;

    constructor(
        domId: string,
        options: BaseBlockOptions = {
            //TO Do delete unused properties
            dict: BaseDict,
            cms: {},
            dataProvider: {},
            panelId: "",
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {

            this.dataProvider = new ScoreboardData(
                new Parser(
                    new Retriever(
                        internalMessageBus,
                        "url(test.png)"
                    )
                )
            );

            window["ScoreboardDATA"] = this.dataProvider;
            window["BaseballScoreboardDataMock"] = new BaseballScoreboardDataMock(internalMessageBus);
            window["BaseballScoreboardDataMock"].activate();
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            this.dataProvider = new ScoreboardData(
                new Parser(
                    new Retriever(
                        options.dataProvider.messageBus,
                        options.dataProvider.backgroundImg
                    )
                )
            );
        }

        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        this.options.cms = { ...config, ...(options.cms || {}) };
    }

    activate() {
        this.dataProvider.activate();
        return super.activate(
            <Scoreboard dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
    deactivate() {
        this.dataProvider.deactivate();
        return super.deactivate();
    }
}

window["Scoreboard"] = ScoreboardRoot;
broadcastBlockLoad("Scoreboard");
